module.exports = __webpack_public_path__ + "img/hx_7.bbd98687.png";